"use client";

import { ICreditLimit } from "@faire/web-api--source/indigofair/data/ICreditLimit";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { ISoftCreditCheckLimitIncreaseResponse } from "@faire/web-api--source/indigofair/data/ISoftCreditCheckLimitIncreaseResponse";
import { createContextStore } from "@faire/web/ui/hooks/ContextStore";

type SccContextStoreType = {
  isTermsAccepted: boolean;
  sccTerms: IFaireMoney | undefined;
  sccState:
    | keyof typeof ISoftCreditCheckLimitIncreaseResponse.IncreaseLimitStatus
    | undefined;
  creditLimit: ICreditLimit | undefined;
};

const { useStore: useSccContextStore, Provider: SccContextStoreProvider } =
  createContextStore<SccContextStoreType>({
    isTermsAccepted: false,
    sccTerms: undefined,
    sccState: undefined,
    creditLimit: undefined,
  });

export { useSccContextStore, SccContextStoreProvider };
